/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  INotificationReceiver,
  INotificationReceiverInterface,
} from "../INotificationReceiver";

const _abi = [
  {
    inputs: [],
    name: "notificationReceiverPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "onAfterTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class INotificationReceiver__factory {
  static readonly abi = _abi;
  static createInterface(): INotificationReceiverInterface {
    return new utils.Interface(_abi) as INotificationReceiverInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): INotificationReceiver {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as INotificationReceiver;
  }
}
